export const postCase = async ({ requestBody, navigate }) => {
  const url = "/api/postCase";

  try {
    if (!requestBody.ContactId) {
      throw new Error(
        "You're not logged in, please click retry to login and then proceed."
      );
    }

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(`API call failed with status ${response.status}`);
    }

    // Check if API returned an error response
    if (responseData?.status === 500) {
      navigate(`/error?message=Internal Server Error`);
      return;
    }

    return responseData;
  } catch (error) {
    console.error("Error saving quote:", error);
    navigate(`/error?message=${encodeURIComponent(error.message)}`);
  }
};
